/**
 * SEO 配置 - chat (Bahasa Indonesia)
 */

export default {
    chat: {
        title: 'Obrolan AI - Asisten Multi-Model | WeryAI',
        description:
            'Ngobrol dengan model AI terbaik di WeryAI. Bandingkan jawaban secara berdampingan di beberapa jendela. Buat gambar, video, dan musik dari satu ruang kerja AI terpadu.',
        keywords:
            'obrolan AI, asisten AI, obrolan multi-model, chatbot AI, bandingkan model AI, obrolan AI berdampingan, alternatif GPT, ruang kerja AI, WeryAI',
        og_title: 'Obrolan AI - Asisten Multi-Model | WeryAI',
        og_description:
            'Ngobrol dengan model AI terbaik dan bandingkan jawaban secara berdampingan. Buat gambar, video, dan lainnya. Coba gratis di WeryAI.',
        twitter_title: 'Obrolan AI - Asisten Multi-Model | WeryAI',
        twitter_description:
            'Ngobrol dengan model AI terbaik dan bandingkan jawaban secara berdampingan. Buat gambar, video, dan lainnya. Coba gratis di WeryAI.',
    },
}
